// extracted by mini-css-extract-plugin
export default {"container":"micromag-preview_container__3kRIl","video":"micromag-preview_video__1AqKJ"};